import { Logo } from "@/components/Logo";
import { Instagram } from "lucide-react";

export const Footer = ({ brands }) => (
  <footer className="border-t border-zinc-200 bg-white pt-24 pb-12" data-testid="footer">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
        <div className="md:col-span-5">
          <Logo size="lg" />
          <p className="text-zinc-400 text-sm leading-relaxed mt-6 max-w-sm">
            Your complete beauty destination. Skincare, haircare, grooming and
            wellness from the brands you trust — with new brands joining every month.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.4em] text-gold mb-6">Brands</p>
          <ul className="space-y-3">
            {brands.map((b) => (
              <li key={b.id} className="flex items-center justify-between gap-3">
                <a
                  href={b.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-500 text-sm hover:text-gold transition-colors duration-300"
                >
                  {b.name} — {b.category}
                </a>
                {b.instagram_profile && (
                  <a
                    href={b.instagram_profile}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-instagram-${b.slug}`}
                    className="text-zinc-400 hover:text-gold transition-colors duration-300"
                    aria-label={`${b.name} on Instagram`}
                  >
                    <Instagram size={15} />
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.4em] text-gold mb-6">Maison</p>
          <ul className="space-y-3 text-sm text-zinc-500">
            <li><a href="/shop" className="hover:text-gold transition-colors duration-300">The Collection</a></li>
            <li><a href="/#brands" className="hover:text-gold transition-colors duration-300">The Brands</a></li>
            <li><a href="/#manifesto" className="hover:text-gold transition-colors duration-300">Manifesto</a></li>
            <li><a href="/admin" className="hover:text-gold transition-colors duration-300">Admin</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200 pt-8 flex flex-wrap justify-between gap-4">
        <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-400">© MMXXVI ViRa. All rights reserved.</p>
        <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-400">Beauty, curated beyond compare.</p>
      </div>
    </div>
  </footer>
);
